import {ExtendedModInfo} from './modsDetector';
import logger from './logging';
import * as process from 'process';

declare global {
    var $mods: ExtendedModInfo[] | undefined
}

const knownDlcList: { [name: string]: () => boolean | undefined } = {
    'Stray Pubes DLC': () => globalThis.DLC_HAIR,
    'Gym DLC': () => globalThis.DLC_GYM,
    'P-Cup DLC': () => globalThis.DLC_PCUP
}

export type ErrorContext = {
    game: {
        version: string | null,
        dlc: {
            name: string,
            isEnabled: boolean | null
        }[]
    },
    device: {
        platform: string,
        arch: string,
        node: string,
    }
    mods: {
        name: string,
        displayedName?: string,
        version?: string,
        source: string
    }[],
    error?: any
}

export function getErrorContext(error?: any): ErrorContext {
    function getLoadedModsList(mods: ExtendedModInfo[]) {
        return mods
            .filter((mod) => !mod.parameters.optional)
            .map((mod) => {
                return {
                    name: mod.name,
                    displayedName: mod.parameters.displayedName,
                    version: mod.parameters.version,
                    source: mod.source,
                };
            });
    }

    const dlcList: ErrorContext['game']['dlc'] = [];
    for (const [name, getStatus] of Object.entries(knownDlcList)) {
        const isEnabled = getStatus() || null;

        dlcList.push({
            name,
            isEnabled
        });
    }

    const mods: ErrorContext['mods'] = getLoadedModsList(globalThis.$mods || []);

    const errorContext: ErrorContext = {
        game: {
            version: globalThis.RemGameVersion || null,
            dlc: dlcList
        },
        device: {
            platform: process.platform,
            arch: process.arch,
            node: process.version
        },
        mods,
        error
    }
    logger.info({errorContext}, 'Generated error context');

    return errorContext;
}
